export const VOICE_STATUS_COPY = Object.freeze({
  preparing: "Preparando o microfone…",
  listening: "Estou ouvindo…",
  thinking: "Pensando…",
  speaking: "Respondendo…",
  waiting: "Toque no núcleo para falar",
  error: "A voz ficou indisponível",
});

export function recognitionConstructor(scope = globalThis) {
  return scope?.SpeechRecognition || scope?.webkitSpeechRecognition || null;
}

export function normalizeVoiceTranscript(value) {
  return String(value || "").replace(/\s+/g, " ").trim();
}

export function voiceStatusCopy(status) {
  return VOICE_STATUS_COPY[status] || VOICE_STATUS_COPY.waiting;
}
